import { createCookie } from './cookieHelper';

enum UtmParamNames {
  utm_source = 'utm_source',
  utm_medium = 'utm_medium',
  utm_campaign = 'utm_campaign',
  utm_content = 'utm_content',
  tp_channel = 'tp_channel',
  msclkid = 'msclkid',
}

type Params = {
  [k: string]: string;
};

export function getQueryStringParams(): Params {
  const queryString = window.location.search.substring(1).split('&');

  return queryString.reduce((acc, val) => {
    const [key, value] = val.split('=');
    if (key && value) {
      acc[key] = value;
    }
    return acc;
  }, {} as Params);
}

export function writeUtmParamsIntoCookie(): void {
  const qsParams = getQueryStringParams();

  Object.keys(qsParams).map((param) => {
    if (param in UtmParamNames) {
      const expireDate = new Date();
      /** store the cookie for 2 hours */
      expireDate.setHours(expireDate.getHours() + 2);
      createCookie(param, qsParams[param], expireDate);
    }

    return true;
  });
}
